module.exports = __webpack_public_path__ + "static/media/sectionAvatarPlaceholder.7126535f.png";